<script setup lang="ts">
import { Tabs } from '@/shared/ui/Tabs'

import { useProfileTabs, type ProfileTabName } from '../model/useProfileTabs'

defineProps<{
  value: ProfileTabName
}>()

const { tabs, open } = useProfileTabs()
</script>

<template>
  <Tabs :model-value="value" :tabs="tabs" @update:model-value="open" />
</template>
